// Helper para obtener la URL base del API correctamente
export function getApiBaseUrl() {
    // En desarrollo, usar rutas relativas para que funcione el proxy de Vite
    // En producción, usar la URL configurada en las variables de entorno
    if (import.meta.env.DEV) {
        return '';  // Rutas relativas para usar el proxy de Vite
    } else {
        return import.meta.env.VITE_APP_BASE_URL || '';
    }
}

export default getApiBaseUrl;